<template>

  <div>
    <b-row
      class="content-header"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        cols="12"
        md="12"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h1 class="custom-header-title">
              Editing {{ existAnnouncementCat.name }}
            </h1>
            <p class="log_info">
              Created by {{ existAnnouncementCat.createdBy ? existAnnouncementCat.createdBy.name : '' }} on {{ dateFormatWithTime(existAnnouncementCat.createdAt) }} <br>Last updated on {{ dateFormatWithTime(existAnnouncementCat.updatedAt) }}
            </p>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-alert
      variant="primary"
      show
    >
      <div class="alert-body">
        <span class="weight-400"><strong class="weight-700">For Nirvana Agent SG:</strong> This is the control panel where administrators can edit the content for the agent-facing mobile app.</span>
      </div>
    </b-alert>
    <!-- Table Container Card -->
    <b-form @submit.prevent="validateForm">
      <validation-observer
        ref="announcementCategoryEditForm"
        #default="{invalid}"
      >
        <b-card
          header-tag="header"
        >
          <b-row>
            <b-col cols="md-12">
              <b-form-group
                label="Category*"
                label-for="h-category-name"
                label-cols-md="2"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Category"
                  vid="name"
                  rules="required"
                >
                  <b-form-input
                    id="h-category-name"
                    v-model="name"
                    placeholder="Category"
                    :state="(errors.length > 0 || nameValidation) ? false : null"
                    name="name"
                    @input="nameValidation == true ? nameValidation = false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                  <small
                    v-if="nameValidation"
                    class="text-danger"
                  >
                    {{ nameError }}
                  </small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="md-12">
              <validation-provider
                #default="{ errors }"
                name="Status"
                vid="status"
                rules="required"
              >
                <b-form-group
                  label="Status*"
                  label-for="h-category-status"
                  label-cols-md="2"
                  :state="(errors.length > 0 || statusValidation) ? false : null"
                >
                  <v-select
                    id="h-category-status"
                    v-model="status"
                    label="title"
                    :options="statusOptions"
                    :reduce="title => title.code"
                    :clearable="false"
                    @input="statusValidation == true ? statusValidation = false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                  <small
                    v-if="statusValidation"
                    class="text-danger"
                  >
                    {{ statusError }}
                  </small>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
        </b-card>

        <all-announcement />

        <b-nav class="wrap-border save-nav">
          <li
            class="nav-item ml-auto"
          >
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="button"
              variant="flat-primary"
              @click="cancelEdit"
            >
              Cancel
            </b-button>
          </li>
          <li
            class="nav-item mr-1"
          >
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="success"
              :disabled="invalid"
            >
              <feather-icon
                icon="SaveIcon"
                class="mr-50"
              />
              <span class="align-middle">Save Changes</span>
            </b-button>
          </li>
        </b-nav>
      </validation-observer>
    </b-form>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard, BRow, BCol, BFormGroup, BFormInput, BForm, BButton, BNav, BAlert,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import { required } from '@validations'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import AllAnnouncement from '../announcements/all-announcements/AllAnnouncement.vue'
import '@core/scss/vue/libs/vue-flatpicker.scss'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BNav,
    BAlert,

    vSelect,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    ValidationProvider,
    ValidationObserver,
    AllAnnouncement,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      existAnnouncementCat: {},
      name: '',
      status: 'active',
      nameError: 'Valid category is required',
      nameValidation: false,
      statusValidation: false,
      statusError: 'Valid status is required',
      statusOptions: [
        { title: 'Active', code: 'active' },
        { title: 'Inactive', code: 'inactive' },
      ],
      // validation rules
      required,
    }
  },

  created() {
    this.$http.get(`customer/announcement-categories/${this.$route.params.id}`)
      .then(response => {
        this.existAnnouncementCat = response.data
        this.name = response.data.name || ''
        this.status = response.data.status || 'active'

        const bcLength = store.state.breadcrumb.breadcrumbs.length
        if (bcLength > 1) {
          store.commit('breadcrumb/REMOVE_BREADCRUMB')
        }
        if (this.name) {
          const newMeta = {
            active: true,
            text: `Editing ${this.name}`,
          }
          store.commit('breadcrumb/UPDATE_BREADCRUMB', newMeta)
        }
      })
      .catch(error => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  },
  methods: {
    cancelEdit() {
      this.$swal({
        title: 'Are you sure?',
        html: 'Selecting Cancel will <strong>undo any changes</strong> you have made. This action cannot be undone.',
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/warning.png'),
        imageWidth: 80,
        imageHeight: 80,
        imageAlt: 'Custom Icon',
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonText: 'Yes, Cancel!',
        cancelButtonText: 'No, Go Back',
        customClass: {
          confirmButton: 'btn btn-danger ml-1',
          cancelButton: 'btn btn-outline-primary',
        },
        buttonsStyling: false,
      })
        .then(result => {
          if (result.value) {
            this.$router.push({ name: 'agencies-announcement-categories-index', params: { type: 'all-announcement-category' } })
          }
        })
    },
    validateForm() {
      this.$refs.announcementCategoryEditForm.validate().then(success => {
        if (success) {
          if (this.existAnnouncementCat.announcementCount && this.existAnnouncementCat.status === 'active' && this.status === 'inactive') {
            this.$swal({
              title: 'Deactivate this Announcement Category',
              html: `You are about to deactivate all <strong>${this.existAnnouncementCat.announcementCount} announcements</strong> in this category, unless any are assigned to a different category. Agents will lose access to these announcements, but you can reactivate them at any time in the future.`,
              // eslint-disable-next-line global-require
              imageUrl: require('@/assets/images/icons/warning.png'),
              reverseButtons: true,
              showCancelButton: true,
              cancelButtonText: 'No, go back',
              confirmButtonText: 'Yes, proceed',
              customClass: {
                confirmButton: 'btn btn-primary ml-1',
                cancelButton: 'btn btn-outline-primary',
              },
              buttonsStyling: false,
              width: 537,
            })
              .then(async result => {
                if (result.value) {
                  this.submitForm()
                }
              })
          } else {
            this.submitForm()
          }
        }
      })
    },
    submitForm() {
      this.$refs.announcementCategoryEditForm.validate().then(success => {
        if (success) {
          const formData = new FormData()

          formData.append('name', this.name)
          formData.append('status', this.status)

          this.$http.patch(`customer/announcement-categories/${this.$route.params.id}/update`, formData)
            .then(() => {
              this.$swal({
                title: 'Announcement Category Updated',
                html: 'Changes made to this announcement category has been saved.',
                // eslint-disable-next-line global-require
                imageUrl: require('@/assets/images/icons/save.png'),
                imageWidth: 80,
                imageHeight: 80,
                imageAlt: 'Custom Icon',
                showCancelButton: true,
                reverseButtons: true,
                cancelButtonText: 'Return to Announcement Categories',
                allowOutsideClick: false,
                confirmButtonText: 'View Entry',
                customClass: {
                  confirmButton: 'btn btn-primary ml-1',
                  cancelButton: 'btn btn-outline-primary',
                },
                buttonsStyling: false,
                width: 550,
              })
                .then(result => {
                  if (result.value) {
                    this.$router.push({ name: 'agencies-announcement-categories-show', params: { id: this.$route.params.id } })
                  } else {
                    this.$router.push({ name: 'agencies-announcement-categories-index', params: { type: 'all-announcement-category' } })
                  }
                })
            })
            .catch(error => {
              if (error.data.errors) {
                error.data.errors.forEach(validationError => {
                  if (validationError.param === 'name') {
                    this.nameError = validationError.msg
                    this.nameValidation = true
                  } else if (validationError.param === 'status') {
                    this.statusError = validationError.msg
                    this.statusValidation = true
                  }
                })

                const items = document.getElementsByClassName('text-danger')
                window.scrollTo({
                  top: items[0].offsetTop,
                  behavior: 'smooth',
                })
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              }
            })
        }
      })
    },
  },
}
</script>

<style scoped>
  .removeText {
    color:#D91B35;
    cursor: pointer;
  }
  .addOptionText {
    color: #104D9D;
    cursor: pointer;
  }
  .btn-group-toggle [class*=btn-outline-]:not(:last-child) {
    border-right-width: 1px !important;
  }
  .inlineElement {
    display: flex;
  }
</style>
